<div class="modal-header">
  <h4 class="modal-title"><i class="fas fa-cog"></i> {{ "TITLE.TABLE-PROPERTIES" | translate }}</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-4" [ngbTooltip]="tipWidth">
      <label class="font-weight-bold mb-0">{{"LABEL.WIDTH" | translate}}</label>
      <input class="form-control" [(ngModel)]="tableProperty.width" placeholder="Ingrese ancho en pixels"/>
    </div>
    <div class="col-md-4" [ngbTooltip]="tipHeight">
      <label class="font-weight-bold mb-0">{{"LABEL.HEIGHT" | translate}}</label>
      <input class="form-control" [(ngModel)]="tableProperty.height" placeholder="Ingrese altura en pixels"/>
    </div>
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.LINE-HEIGHT" | translate}}</label>
      <select class="form-control" [(ngModel)]="tableProperty.lineHeight">
        <option *ngFor="let value of lineHeights" [value]="value">{{value}}</option>
      </select>
    </div>
  </div>
  <br>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success"
          (click)="accept()"><i class="fas fa-exchange-alt"></i> {{ "BUTTON.APPLY-CHANGE" | translate }}</button>
</div>

<ng-template
  #tipWidth>
  {{"MESSAGE.MAX-CONTENT-WIDTH-TABLE" | translate}}
</ng-template>

<ng-template
  #tipHeight>
  {{"MESSAGE.MAX-CONTENT-HEIGHT-TABLE"| translate}}
</ng-template>
